import React, { useState, useEffect } from "react";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import SearchOutlined from "@mui/icons-material/SearchOutlined";
import { Box, Tooltip, Input } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { getListTicket } from "../Store/Actions/ChatAction";
import { toast } from "react-toastify";

const columns = [
  { field: "TicketNo", headerName: "Ticket Number", flex: 1, minWidth: 100 },
  { field: "Title", headerName: "Title", flex: 1, minWidth: 100 },
  { field: "CustomerName", headerName: "CustomerName", flex: 1, minWidth: 100 },
];

const EditTicketModal = ({ onClose, confirmEndChat }) => {
  const initials = {
    isLoading: false,
    data: [],
    total: 0,
    page: 1,
    pageSize: 10,
  };

  const [pageTicket, setPageTicket] = useState(initials);
  const [searchTicket, setsearchTicket] = useState("");
  const [searchContain, setSearchContain] = useState(false);

  useEffect(() => {
    if (searchTicket) {
      const searchRegex = /^./;
      const result = searchRegex.test(searchTicket);
      setSearchContain(result);
    }
    const fetchDataList = async () => {
      if (searchTicket === "" || searchTicket.length > 3) {
        setPageTicket((old) => ({ ...old, isLoading: true }));
        const response = await getListTicket(pageTicket.page, searchTicket);
        if (response.status) {
          setPageTicket((old) => ({
            ...old,
            isLoading: false,
            data: response.data.records,
            total: response.data.total,
          }));
        } else toast.warn(response.error);
      }
    };
    fetchDataList();
  }, [pageTicket.page, pageTicket.pageSize, searchTicket]);

  const typeSelect = async () => {
    setPageTicket((old) => ({ ...old, isLoading: true }));
    const response = await getListTicket(pageTicket.page, searchTicket);
    if (response.status) {
      setPageTicket((old) => ({
        ...old,
        isLoading: false,
        data: response.data.records,
        total: response.data.total,
      }));
    } else {
      toast.warn(response.error);
    }
  };

  const clearState = () => {
    setPageTicket({ ...initials });
    onClose();
  };
  const [selectedRows, setSelectedRows] = useState(0);

  const onRowsSelectionHandler = (ids) => {
    const selectedRowsData = ids.map((id) =>
      pageTicket.data.find((row) => row.CaseID === id)
    );
    setSelectedRows(selectedRowsData.length ? selectedRowsData[0].CaseID : 0);
  };

  return (
    <div className="overlayHistory">
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="modalContainerTicket"
      >
        <CloseOutlinedIcon
          className="closeBtn"
          onClick={clearState}
        ></CloseOutlinedIcon>
        <div className="contentTicket">
          <div className="i dont know">{console.log("")}</div>
          <h3
            style={{
              color: "gray",
              alignSelf: "center",
              fontSize: 22,
            }}
          >
            Select Ticket
          </h3>
          <div className="contentEditTicket">
            <div className="HeaderSearchContainer">
              <Box
                sx={{
                  borderColor: "divider",
                  p: 1,
                }}
              >
                <div className="searchbar_container">
                  <SearchOutlined className="search_icon" />
                  <Tooltip title="Press 'Enter' to search contact" arrow>
                    <Input
                      className="searchbarTicket"
                      placeholder="Search..."
                      disableUnderline={true}
                      type="text"
                      value={searchTicket}
                      aria-invalid={searchContain ? "false" : "true"}
                      onChange={(e) => setsearchTicket(e.target.value)}
                      onKeyDown={(e) =>
                        e.key === "Enter" ? typeSelect(searchTicket) : ""
                      }
                    />
                  </Tooltip>
                  {searchContain === false ? (
                    ""
                  ) : (
                    <CloseOutlinedIcon
                      className="clear_search_icon"
                      onClick={() => setsearchTicket("")}
                    />
                  )}
                </div>
              </Box>
            </div>
            <DataGrid
              rows={pageTicket.data}
              rowCount={pageTicket.total}
              loading={pageTicket.isLoading}
              rowsPerPageOptions={[10]}
              pagination
              getRowId={(row) => row.CaseID}
              page={pageTicket.page - 1}
              pageSize={pageTicket.pageSize}
              paginationMode="server"
              onPageChange={(newPage) => {
                setPageTicket((old) => ({ ...old, page: newPage + 1 }));
              }}
              onPageSizeChange={(newPageSize) =>
                setPageTicket((old) => ({ ...old, pageSize: newPageSize }))
              }
              columns={columns}
              disableColumnSelector
              onSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
            />
          </div>
        </div>
        <div className="btnContainerEditTicket">
          <button className="btn_Cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn_Confirm"
            onClick={() => {
              confirmEndChat(1, selectedRows, 0);
            }}
          >
            Convert
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditTicketModal;
